import React from 'react';
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import './CommunityStats.css';

const CommunityStats = () => {
  // Just created this in order to start the countup animation in testimonial section when user reaches that viewport
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  return (
    <div className="community-stats" ref={ref}>
      <h2>Our Growing Community</h2>
      <div className="stats">
        <div className="stat-item">
          <h3>Units</h3>
          <p>
            <CountUp
              scrollSpyOnce={true}
              start={inView ? 2 : 1}
              end={inView ? 19 : 18}
              duration={1}
              suffix="Lakh+" />
          </p>
        </div>
        <div className="stat-item">
          <h3>Customers</h3>
          <p>
          <CountUp
              scrollSpyOnce={true}
              start={inView ? 2 : 1}
              end={inView ? 8 : 7}
              duration={1}
              suffix="Lakh+" />
          </p>
        </div>
        <div className="stat-item">
          <h3>Pincodes</h3>
          <p>
          <CountUp
              scrollSpyOnce={true}
              start={inView ? 501 : 500}
              end={inView ? 1330 : 1329}
              duration={1}
              suffix="+" />
          </p>
        </div>
        <div className="stat-item">
          <h3>Cities</h3>
          <p>
          <CountUp
              scrollSpyOnce={true}
              start={inView ? 2001 : 2000}
              end={inView ? 3200 : 3199}
              duration={1}
              suffix="+" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommunityStats;
